module.exports = __webpack_public_path__ + "img/gift-title.e8e44a02.png";